import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css'
import App from './App.vue';
import router from './router';
import store from './store';
import cookies from 'vue-cookies'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$cookies = cookies;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
